import { post, get } from 'app/shared/utils/fetchr';
import { DetectionModelsNewMetricPayload } from 'app/modules/detectionModels/types/requests';
import {
  DetectionModelExecutionResponse,
  DetectionModelNewMetricResponse,
} from 'app/modules/detectionModels/types/responses';
import { MetricNameEnum } from 'app/modules/detectionModels/constants';
import { PaginationPayload } from 'app/shared/pagination/models';
import {
  DeactivateRuleResponse,
  PaginatedAlerts,
  PaginatedSchedules,
} from 'app/modules/rules/models';

import { DetectionModelValidationResult } from 'app/modules/rules/types/responses';

const DETECTION_MODELS = 'detection-models';
const RULES = 'rules';
export const retrieveDetectionModelNewMetric = (
  ruleId: number,
  metricName: MetricNameEnum,
  payload: DetectionModelsNewMetricPayload,
): Promise<DetectionModelNewMetricResponse> =>
  post(`/v1/${DETECTION_MODELS}/${ruleId}/metric/${metricName}`, payload);

export const deactivateDetectionModel = (
  ruleId: number,
): Promise<DeactivateRuleResponse> => post(`/v1/${RULES}/deactivate/${ruleId}`);

export const retrieveDetectionModelExecutions = (
  ruleId: number,
  payload: PaginationPayload,
): Promise<DetectionModelExecutionResponse> =>
  post(`/v1/${RULES}/${ruleId}/paginated-executions`, payload);

export const retrieveDetectionModelGeneratedAlerts = (
  payload: { id: number } & PaginationPayload,
): Promise<PaginatedAlerts> => {
  const { id, ...details } = payload;
  const path = `/v1/${RULES}/paginated-alerts/${id}`;
  return post(path, details);
};

export const retrieveDetectionModelValidationResults = (payload: {
  id: number;
}): Promise<Array<DetectionModelValidationResult>> => {
  const { id } = payload;
  return get(`/v1/${DETECTION_MODELS}/${id}/validation-results`);
};

export const retrieveDetectionModelExecutionSchedules = (
  ruleId: number,
  executionId: number,
  payload: PaginationPayload,
): Promise<PaginatedSchedules> =>
  post(
    `/v1/${RULES}/${ruleId}/paginated-executions/${executionId}/schedules`,
    payload,
  );

export const retrieveDetectionModelExecutionAlerts = (
  ruleId: number,
  executionId: number,
  payload: PaginationPayload,
): Promise<PaginatedAlerts> =>
  post(
    `/v1/${RULES}/${ruleId}/paginated-executions/${executionId}/alerts`,
    payload,
  );
